module.exports = __webpack_public_path__ + "img/logo1.bae2b1b9.png";